import React, { useState } from 'react';
import { Account_text } from '../../../constant/Translation/Account';
import { Listing_text } from '../../../constant/Translation/Listing';
import OutsideClickHandler from 'react-outside-click-handler';
import PopUp from '../../Shared/PopUp/PopUp';
import SuccessPopUp from '../../Shared/PopUp/Success';
import { get_dynamic_styles_with_default_value } from '../../../constant/DynamicStylesWithDefaultValue';
import {
  CardBoxDefaultStyles,
  CardMainDefaultStyles,
} from '../../../constant/default_styles/ProductDetailsStyles';
import { useDispatch } from 'react-redux';
import { clearListingState } from '../../../store/feature/listingSlice';
import { useRouter } from 'next/router';

const ShareButtons = ({ listing_details, styles }) => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState('');
  const closePopUP = () => {
    setShowAlert(false);
    setMessage('');
  };
  const router = useRouter();

  return listing_details ? (
    <div
      className=" w-full  "
      style={get_dynamic_styles_with_default_value(
        styles?.main_styles,
        CardMainDefaultStyles
      )}
    >
      <div
        style={get_dynamic_styles_with_default_value(
          styles?.box_styles,
          CardBoxDefaultStyles
        )}
      >
        {showAlert && (
          <OutsideClickHandler
            onOutsideClick={() => {
              showAlert &&
                (setShowAlert(false),
                setMessage(''),
                dispatch(clearListingState()));
            }}
          >
            <div className="fixed z-50 top-0 left-0 right-0  w-full  xs:w-[500px] mx-auto mt-5">
              <div className="">
                <SuccessPopUp message={message} closePopUP={closePopUP} />
              </div>
            </div>
          </OutsideClickHandler>
        )}

        <h2 className="heading-h2">{Listing_text.product.share}</h2>
        <div className=" mt-4 flex  items-center  justify-start  gap-4 flex-wrap ">
          <button
            className=" btn    rounded-button border border-primary box-border "
            onClick={() => {
              window.open(`whatsapp://send?text=${window.location.href}`);
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.4984 14.381C17.2006 14.2322 15.7319 13.512 15.4582 13.4136C15.1845 13.314 14.9855 13.2647 14.7866 13.5624C14.5876 13.8589 14.0149 14.5298 13.84 14.7279C13.6664 14.9259 13.4916 14.9499 13.1937 14.8011C12.3136 14.4523 11.5012 13.9535 10.793 13.3272C10.1399 12.7262 9.5799 12.0321 9.13143 11.2675C8.9578 10.9698 9.11334 10.809 9.26286 10.6614C9.3967 10.5281 9.5619 10.3145 9.71021 10.1405C9.83305 9.99021 9.93374 9.8233 10.0092 9.64475C10.049 9.5627 10.0675 9.47207 10.0631 9.38109C10.0586 9.29012 10.0314 9.20168 9.98392 9.12384C9.90916 8.97501 9.3123 7.51188 9.06391 6.91655C8.82154 6.33803 8.57556 6.41604 8.39108 6.40644C8.21744 6.39804 8.01849 6.39564 7.81953 6.39564C7.66819 6.39984 7.51936 6.43517 7.3824 6.49941C7.24544 6.56366 7.12331 6.65542 7.02371 6.76892C6.68612 7.08715 6.41882 7.47189 6.23883 7.89862C6.05884 8.32535 5.97011 8.78472 5.9783 9.24746C6.07512 10.3688 6.49881 11.4376 7.19735 12.3225C8.4778 14.2334 10.2355 15.78 12.2978 16.8103C12.8541 17.0482 13.4224 17.2573 14.0004 17.4369C14.6097 17.621 15.2539 17.6609 15.8814 17.5533C16.2971 17.4695 16.6907 17.3007 17.0375 17.0578C17.3843 16.8148 17.6767 16.5029 17.8963 16.1418C18.0922 15.6976 18.1526 15.2059 18.0699 14.7279C17.9964 14.603 17.7974 14.5298 17.4984 14.381ZM20.5032 3.4838C18.4533 1.44378 15.7285 0.214779 12.8361 0.0256118C9.94367 -0.163555 7.08075 0.700002 4.78033 2.45551C2.4799 4.21102 0.898744 6.73885 0.331222 9.56838C-0.236299 12.3979 0.248491 15.3363 1.69534 17.8365L0 23.9999L6.33521 22.3471C8.08741 23.2968 10.0507 23.7945 12.0458 23.7946H12.0506C14.4141 23.7934 16.7242 23.095 18.689 21.7874C20.6538 20.4799 22.1853 18.6221 23.0898 16.4485C23.9943 14.275 24.2314 11.8834 23.771 9.57584C23.3106 7.26827 22.1735 5.14831 20.5032 3.48379V3.4838ZM17.3284 20.2743C15.7466 21.2612 13.9175 21.7849 12.0506 21.7854H12.0458C10.2672 21.7853 8.52129 21.309 6.99116 20.4063L6.62822 20.1926L2.86857 21.1745L3.87178 17.5257L3.63666 17.1512C2.5931 15.4946 2.06646 13.5673 2.12332 11.6128C2.18018 9.65828 2.81799 7.76446 3.95609 6.1708C5.0942 4.57713 6.6815 3.35519 8.51726 2.65948C10.353 1.96377 12.3548 1.82555 14.2695 2.26229C16.1842 2.69903 17.9257 3.69111 19.274 5.1131C20.6223 6.53508 21.5167 8.3231 21.8441 10.251C22.1715 12.179 21.9172 14.1603 21.1134 15.9444C20.3097 17.7285 18.9924 19.2353 17.3284 20.2743Z"
                fill="var(--primary_color)"
              />
            </svg>
            <span className="text-primary text-base leading-5 font-medium  ltr:ml-3 rtl:mr-3">
              {Listing_text.product.whatsapp}
            </span>
          </button>
          <button
            className="btn  rounded-button border border-primary box-border  "
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
              setShowAlert(true);
              setMessage(
                Listing_text.product.link_copied + ' ' + window.location.href
              );
            }}
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 19 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.5 18H5.5C4.70435 18 3.94129 17.6839 3.37868 17.1213C2.81607 16.5587 2.5 15.7956 2.5 15V5C2.5 4.73478 2.39464 4.48043 2.20711 4.29289C2.01957 4.10536 1.76522 4 1.5 4C1.23478 4 0.98043 4.10536 0.792893 4.29289C0.605357 4.48043 0.5 4.73478 0.5 5V15C0.5 16.3261 1.02678 17.5979 1.96447 18.5355C2.90215 19.4732 4.17392 20 5.5 20H13.5C13.7652 20 14.0196 19.8946 14.2071 19.7071C14.3946 19.5196 14.5 19.2652 14.5 19C14.5 18.7348 14.3946 18.4804 14.2071 18.2929C14.0196 18.1054 13.7652 18 13.5 18ZM18.5 6.94C18.4896 6.84813 18.4695 6.75763 18.44 6.67V6.58C18.3919 6.47718 18.3278 6.38267 18.25 6.3L12.25 0.3C12.1673 0.222216 12.0728 0.158081 11.97 0.11H11.88L11.56 0H7.5C6.70435 0 5.94129 0.316071 5.37868 0.87868C4.81607 1.44129 4.5 2.20435 4.5 3V13C4.5 13.7956 4.81607 14.5587 5.37868 15.1213C5.94129 15.6839 6.70435 16 7.5 16H15.5C16.2956 16 17.0587 15.6839 17.6213 15.1213C18.1839 14.5587 18.5 13.7956 18.5 13V7C18.5 7 18.5 7 18.5 6.94ZM12.5 3.41L15.09 6H13.5C13.2348 6 12.9804 5.89464 12.7929 5.70711C12.6054 5.51957 12.5 5.26522 12.5 5V3.41ZM16.5 13C16.5 13.2652 16.3946 13.5196 16.2071 13.7071C16.0196 13.8946 15.7652 14 15.5 14H7.5C7.23478 14 6.98043 13.8946 6.79289 13.7071C6.60536 13.5196 6.5 13.2652 6.5 13V3C6.5 2.73478 6.60536 2.48043 6.79289 2.29289C6.98043 2.10536 7.23478 2 7.5 2H10.5V5C10.5 5.79565 10.8161 6.55871 11.3787 7.12132C11.9413 7.68393 12.7044 8 13.5 8H16.5V13Z"
                fill="var(--primary_color)"
              />
            </svg>

            <span className="text-primary text-base leading-5 font-medium ltr:ml-3 rtl:mr-3 ">
              {Listing_text.product.copy_link}
            </span>
          </button>
          {navigator.share && (
            <button
              onClick={() => {
                navigator
                  .share({
                    title: `${listing_details?.title}`,
                    url: `${window.location.href}`,
                  })
                  .then(() => {
                    // alert('Thanks for sharing!');
                  })
                  .catch();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-primary"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  ) : (
    <div>
      <div className="border bg-[#3B3269] bg-opacity-[10%] shadow rounded-card   p-4   w-full  mx-auto overflow-hidden">
        <div className="flex  justify-between">
          <div className="h-3 bg-[#3B3269] bg-opacity-[20%] rounded-full   w-28"></div>
        </div>
        <div className="animate-pulse mt-4  ">
          <div className="w-full  min-h-min flex  items-center justify-center xs:justify-start  gap-5 flex-wrap">
            <div className="h-8 bg-[#3B3269] bg-opacity-[20%] rounded-card   w-28"></div>
            <div className="h-8 bg-[#3B3269] bg-opacity-[20%] rounded-card   w-28"></div>
            <div className="h-8 bg-[#3B3269] bg-opacity-[20%] rounded-card   w-28"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShareButtons;
